import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './button.module.scss';

export interface IButtonProps {
  children: ReactNode;
  size?: 'default' | 'normal';
  onClick?: () => void;
  color?: 'none' | 'green' | 'dark' | 'black' | 'green-opaque' | 'dark-lighten';
  radius?: 'none' | 'normal' | 'pill';
  type?: 'button' | 'submit';
  disabled?: boolean;
  withIcon?: boolean;
  className?: string;
}

const Button = ({
  size = 'default',
  color = 'none',
  radius = 'none',
  type = 'button',
  className = '',
  withIcon = false,
  ...rest
}: IButtonProps): JSX.Element => {
  const classNames = cn(styles.button, className, {
    [styles[`button-color-${color}`]]: color,
    [styles[`button-radius-${radius}`]]: radius,
    [styles.withIcon]: withIcon,
    [styles.normalSize]: size === 'normal',
  });

  return <button className={classNames} type={type} {...rest} />;
};

export default Button;
